if (typeof complementaryProductsComponentMobile === 'undefined')
{   
    class ComplementaryProductsComponentMobile extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const url = this.dataset.url;

            this.buildProducts(url);    
            console.log("this", this);
            
        }

        buildProducts(url) {
            const fetchProducts = async (url) => {
                const res = await fetch(url);
                let text = await res.text();
                    
                const html = document.createElement('div');
                text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div').replaceAll('product-tab', 'div').replaceAll('compare-color', 'div');
                html.innerHTML = text;
                
                const recommendations = html.querySelector('[data-complementary-product-mobile]');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
    
                    if (window.sharedFunctions.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    }
                }
                    
                const productCarousel = this.querySelector('.products-carousel');
                this.initializeSlider(productCarousel);
            }
    
            fetchProducts(url);
        }
        
        initializeSlider(productCarousel = null) {
            if (productCarousel) {
                const itemArrows = productCarousel.dataset.itemArrows === 'true';
                const itemDots = productCarousel.dataset.itemDots === 'true';
                const itemRows = parseInt(productCarousel.dataset.itemRows);
                const itemToShow = Number(productCarousel.dataset.itemToShow);
                const complementaryStyle = this.classList.contains('style-1') ? true : false;

                $(productCarousel).on('init', () => {
                    this.calculateCard06Padding();
                });

                if(!productCarousel.classList.contains('slick-slider')) {
                    $(productCarousel).slick({
                        dots: false,
                        arrows: true,
                        slidesToShow: itemToShow,
                        slidesToScroll: 1,
                        infinite: false,
                        rtl: false,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,

                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 1025,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 945,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 850,
                                settings: {
                                    slidesToShow: 3.5,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3.2,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 650,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 399,
                                settings: {
                                    slidesToShow: 1.5,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 321,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    arrows: false
                                }
                            }
                        ]
                    });

                }
            }
        }
        
        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const selectOptionsHeight = this.querySelector('.product .card-action').scrollHeight;
            this.querySelector('.slick-list').style.paddingBottom = selectOptionsHeight + 'px';
        }
    }
    
    window.addEventListener('load', () => {
        
        customElements.define('complementary-products-mobile', ComplementaryProductsComponentMobile);
    })

    var complementaryProductsComponentMobile = ComplementaryProductsComponentMobile;
}